import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import Typography from "@mui/material/Typography";
import { baseUrlnoPort } from "../api/AdminApi";

export default function VehicleMediaCard({ imageUrl, callback }) {
  const [img, setImg] = useState(imageUrl);
  const [src, setSrc] = useState();

  useEffect(() => {
    if (img !== "") {
      console.log(img);
      if (img instanceof File) {
        setSrc(URL.createObjectURL(img));
        //callback(URL.createObjectURL(img))
        console.log(img);
      } else {
        setSrc(baseUrlnoPort + img);
      }
    }
  }, [img]);

  const handleRemove = () => {
    setImg("");
    //props.addImageCallback(null);
  };

  const addImage = (e) => {
    //setImg(img)
    setImg(e.target.files[0]);
    callback(e.target.files[0]);
  };

  return (
    <Box>
      {img ? (
        <Card sx={{ maxWidth: 250, maxHeight: 250 }}>
          <CardMedia component="img" height="140" image={src} />
          <CardActions>
            <Button size="small" onClick={handleRemove}>
              Remove
            </Button>
          </CardActions>
        </Card>
      ) : (
        <Card sx={{ maxWidth: 250, maxHeight: 250 }}>
          <CardActions>
            <Button variant="contained" component="label" onChange={addImage}>
              Upload
              <input hidden className="form-control" type="file" />
            </Button>
          </CardActions>
        </Card>
      )}
    </Box>
  );
}
